module.exports = __webpack_public_path__ + "img/what-we-sell_0001.e8d0f690.jpg";